export const AUTO_SCROLL_TO_ACTIVE_INDEX_OFFSET_X = -200;
